export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط وربط التطبيق المصادقة عبر إدخال وتأكيد رمز المصادقة الصالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["امسح الرمز الشريطي QR أو استخدم الرمز الموجود أدناه لتوليد أكواد التوثيق في تطبيق التوثيق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-DZ": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل وربط تطبيق التحقق عن طريق إدخال وتأكيد كود التحقق الصالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["امسح رمز الاستجابة السريعة أو استخدم الرمز الذي يوجد أدناه لإنشاء أكواد المصادقة في تطبيق المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التوثيق غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-EG": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل وربط تطبيق التوثيق بواسطة إدخال وتأكيد كود توثيق صالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["امسح رمز QR أو استخدم الرمز الذي تحته لتوليد أكواد التحقق في تطبيق التحقق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-LB": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط وربط تطبيق التفويض عن طريق إدخال وتأكيد كود تفويض صالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["استخدم رمز الاستجابة السريعة أو استعمل الرمز الذي أدناه لإنتاج رموز التصديق في تطبيق التصديق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-MA": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل وربط التطبيق بواسطة إدخال وتأكيد رمز التوثيق الصحيح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بمسح رمز QR أو استخدم الرمز الموجود أدناه لإنشاء أكواد التوثيق في تطبيق التوثيق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ادخل رمز التأكيد"])}
          }
        }
      },
      "ar-SA": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط وربط تطبيق المصادقة بواسطة إدخال وتأكيد رمز المصادقة الصحيح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["امسح رمز الاستجابة السريعة أو استخدم الرمز الذي أسفله لتوليد أكواد المصادقة في تطبيق المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-SY": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط وربط تطبيق المصادقة من خلال إدخال وتأكيد رمز المصادقة الصالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قراءة الرمز الشريطي QR أو استخدام الرمز الذي في الأسفل لتوليد أكواد التصديق في ابتأليف التصديق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "ar-TN": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط وربط تطبيق التفويض عن طريق إدخال وتأكيد كود تفويض صالح من التطبيق."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اقرأ رمز الاستجابة السريعة أو استخدم الرمز الموجود بالاسفل لتوليد أكواد التوثيق في تطبيق التوثيق."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        }
      },
      "bg-BG": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране и свързване на автентикационното приложение чрез въвеждане и потвърждаване на валиден автентикационен код от приложението."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение за удостоверяване"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сканирайте QR кода или използвайте кода по-долу, за да генерирате кодове за удостоверяване в приложението за удостоверяване."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е невалиден"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване от приложението за удостоверяване"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете код за удостоверяване"])}
          }
        }
      },
      "bs-BA": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija i povezivanje autentifikacijske aplikacije putem unosa i potvrđivanja valjanog autentifikacijskog koda iz aplikacije."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenirajte QR kod ili koristite kod ispod da generišete autentifikacione kodove u aplikaciji za autentifikaciju."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite kod za autentifikaciju"])}
          }
        }
      },
      "cs-CZ": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivace a propojení autentizační aplikace zadáním a potvrzením platného ověřovacího kódu z aplikace."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační aplikace"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naskenujte QR kód nebo použijte kód níže k vygenerování ověřovacích kódů v aplikaci pro ověření."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód je neplatný"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační kód z autentizační aplikace"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte ověřovací kód"])}
          }
        }
      },
      "da-DK": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering og tilknytning af godkendelsesprogrammet ved indtastning og bekræftelse af en gyldig godkendelseskode fra programmet."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringsapp"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan QR-koden eller brug koden nedenfor til at generere godkendelseskoder i en godkendelsesapp."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden er ugyldig"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringskode fra autentificeringsappen"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast godkendelseskode"])}
          }
        }
      },
      "de-DE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung und Verknüpfung der Authentifizierungs-App durch Eingabe und Bestätigung eines gültigen Authentifizierungscodes aus der App."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR-Code scannen oder den darunter stehenden Code verwenden, um Authentifizierungscodes in einer Authentifizierungs-App zu generieren."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        }
      },
      "de-AT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung und Verknüpfung der Authentifizierungs-App durch Eingabe und Bestätigung eines gültigen Authentifizierungscodes aus der App."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR-Code scannen oder den darunter stehenden Code verwenden, um Authentifizierungscodes in einer Authentifizierungs-App zu generieren."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        }
      },
      "de-CH": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung und Verknüpfung der Authentifizierungs-App durch Eingabe und Bestätigung eines gültigen Authentifizierungscodes aus der App."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR-Code scannen oder den darunter stehenden Code verwenden, um Authentifizierungscodes in einer Authentifizierungs-App zu generieren."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        }
      },
      "de-LU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung und Verknüpfung der Authentifizierungs-App durch Eingabe und Bestätigung eines gültigen Authentifizierungscodes aus der App."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR-Code scannen oder den darunter stehenden Code verwenden, um Authentifizierungscodes in einer Authentifizierungs-App zu generieren."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        }
      },
      "el-GR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση και σύνδεση της εφαρμογής επικύρωσης με την εισαγωγή και επιβεβαίωση ενός έγκυρου κωδικού επικύρωσης από την εφαρμογή."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σαρώστε τον κώδικα QR ή χρησιμοποιήστε τον κωδικό που βρίσκεται παρακάτω για να δημιουργήσετε κωδικούς επαλήθευσης σε μια εφαρμογή επαλήθευσης."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])}
          }
        }
      },
      "el-CY": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση και σύνδεση της εφαρμογής πιστοποίησης με την εισαγωγή και επιβεβαίωση ενός έγκυρου κωδικού πιστοποίησης από την εφαρμογή."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σαρώστε τον κώδικα QR ή χρησιμοποιήστε τον κωδικό παρακάτω για να δημιουργήσετε κωδικούς πιστοποίησης σε μια εφαρμογή πιστοποίησης."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])}
          }
        }
      },
      "en-GB": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation and linking of the authentication app by inputting and confirming a valid authentication code from the app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan the QR code or use the code below to generate authentication codes in an authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        }
      },
      "en-IE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation and linking of the authentication app by entering and confirming a valid authentication code from the app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan the QR code or use the code below to generate authentication codes in an authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        }
      },
      "en-US": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation and linking of the authentication app by entering and confirming a valid authentication code from the app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan the QR code or use the code below to generate authentication codes in an authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        }
      },
      "es-ES": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activación y vinculación de la aplicación de autenticación mediante la introducción y confirmación de un código de autenticación válido de la aplicación."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicación de autenticación"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escanee el código QR o use el código de abajo para generar códigos de autenticación en una aplicación de autenticación."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación es inválido"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación de la aplicación de autenticación"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el código de autenticación"])}
          }
        }
      },
      "et-EE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimisrakenduse aktiveerimine ja sidumine, sisestades ja kinnitades rakendusest pärit kehtiva autentimiskoodi."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimisrakendus"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skaneeri QR-koodi või kasuta allpool olevat koodi autentimiskoodide loomiseks autentimisrakenduses."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood on kehtetu"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood autentimisrakendusest"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage autentimiskood"])}
          }
        }
      },
      "fi-FI": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todentamissovelluksen aktivointi ja yhdistäminen syöttämällä ja vahvistamalla sovelluksesta peräisin oleva kelvollinen todennuskoodi."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennussovellus"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skannaa QR-koodi tai käytä alla olevaa koodia tunnistuskoodien generoimiseksi tunnistussovelluksessa."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi on virheellinen"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentikointikoodi autentikointisovelluksesta"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjoita tunnistekoodi"])}
          }
        }
      },
      "fr-BE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation et liaison de l'application d'authentification en saisissant et en confirmant un code d'authentification valide depuis l'application."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan the QR code or use the code below to generate authentication codes in an authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le code d'authentification"])}
          }
        }
      },
      "fr-CH": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation et liaison de l'application d'authentification en saisissant et en confirmant un code d'authentification valide depuis l'application."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannez le code QR ou utilisez le code ci-dessous pour générer des codes d'authentification dans une application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        }
      },
      "fr-FR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation et liaison de l'application d'authentification en saisissant et en confirmant un code d'authentification valide depuis l'application."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannez le code QR ou utilisez le code ci-dessous pour générer des codes d'authentification dans une application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        }
      },
      "fr-LU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation et liaison de l'application d'authentification en saisissant et en confirmant un code d'authentification valide de l'application."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez scanner le QR-Code ou utiliser le code ci-dessous pour générer des codes d'authentification dans une application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        }
      },
      "ga-IE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtú agus nascadh an aip fíordheimhnithe trí cód fíordheimhnithe bailí a iontráil agus a dhaingniú ón aip."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aip Authindála"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan an cód QR nó úsáid an cód thíos chun códanna fíordheimhnithe a ghiniúint i app fíordheimhniúcháin."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tá an cód fíordheimhnithe neamhbhailí"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód Fíordheimhnithe ón gCleas Fíordheimhnithe"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach cód fíordheimhnithe"])}
          }
        }
      },
      "he-IL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הפעלה וחיבור של אפליקציית האימות על ידי הכנסת ואישור של קוד אימות תקף מהאפליקציה."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אפליקציית אימות"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סרוק את קוד ה- QR או השתמש בקוד שלהלן כדי ליצור קודי אימות באפליקציה לאימות."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות אינו חוקי"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות מאפליקציית האימות"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן קוד אימות"])}
          }
        }
      },
      "hi-IN": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ऐप से मान्य प्रमाणीकरण कोड दर्ज करके और पुष्टि करके प्रमाणीकरण ऐप को सक्रिय करें और जोड़ें."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्यूआर कोड स्कैन करें या नीचे दिए गए कोड का उपयोग करके एक प्रमाणीकरण ऐप में प्रमाणीकरण कोड उत्पन्न करें।"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि करें"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड अमान्य है"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप से प्रमाणीकरण कोड"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड दर्ज करें"])}
          }
        }
      },
      "hr-HR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija i povezivanje aplikacije za autentikaciju unosom i potvrdom valjanog autentikacijskog koda iz aplikacije."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenirajte QR kod ili upotrijebite kod ispod za generiranje autentifikacijskih kodova u aplikaciji za autentifikaciju."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite autentifikacijski kod"])}
          }
        }
      },
      "hu-HU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az hitelesítő alkalmazás aktiválása és összekapcsolása egy érvényes hitelesítő kód megadásával és megerősítésével az alkalmazásból."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő alkalmazás"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olvassa be a QR-kódot vagy használja az alábbi kódot a hitelesítési kódok generálásához a hitelesítési alkalmazásban."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az hitelesítési kód érvénytelen"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód a hitelesítő alkalmazásból"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg az hitelesítő kódot"])}
          }
        }
      },
      "it-CH": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione e collegamento dell'app di autenticazione inserendo e confermando un codice di autenticazione valido dall'app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scansiona il codice QR o utilizza il codice sottostante per generare codici di autenticazione in un'app di autenticazione."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])}
          }
        }
      },
      "it-IT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione e collegamento dell'app di autenticazione inserendo e confermando un codice di autenticazione valido dall'app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scansiona il codice QR o usa il codice qui sotto per generare codici di autenticazione in un'app di autenticazione."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])}
          }
        }
      },
      "ja-JP": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アプリから有効な認証コードを入力し、確認して認証アプリを有効化し、リンクします。"])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリ"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QRコードをスキャンするか、以下のコードを使用して認証アプリで認証コードを生成します。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが無効です"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリからの認証コード"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力してください"])}
          }
        }
      },
      "ko-KR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["앱에서 유효한 인증 코드를 입력하고 확인하여 인증 앱을 활성화하고 연결합니다."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR 코드를 스캔하거나 아래 코드를 사용하여 인증 앱에서 인증 코드를 생성합니다."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["확인"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드가 유효하지 않습니다"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱에서의 인증 코드"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드를 입력하세요"])}
          }
        }
      },
      "lt-LT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo programos aktyvinimas ir susiejimas įvedant ir patvirtinant galiojantį autentifikavimo kodą iš programos."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo programa"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuskanuokite QR kodą arba naudokite žemiau esantį kodą, kad sugeneruotumėte autentifikacijos kodus autentifikacijos programe."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas netinkamas"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas iš autentifikacijos programos"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite autentifikacijos kodą"])}
          }
        }
      },
      "lv-LV": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas lietojumprogrammas aktivizēšana un saistīšana, ievadot un apstiprinot derīgu autentifikācijas kodu no lietojumprogrammas."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas lietotne"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noskanējiet QR kodu vai izmantojiet zemāk esošo kodu, lai ģenerētu autentifikācijas kodus autentifikācijas lietotnē."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods ir nederīgs"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods no autentifikācijas lietotnes"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet autentifikācijas kodu"])}
          }
        }
      },
      "mt-MT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazzjoni u ħolqien tal-app ta' awtentikazzjoni billi tieħu u tiċċonferma kodiċi ta' awtentikazzjoni validu mill-app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App ta' awtentikazzjoni"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanja l-kodiċi QR jew uża l-kodiċi hawn taħt biex tiġġenera kodiċi ta' awtentikazzjoni f'app ta' awtentikar."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentiċità mhux validu"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' awtentiċazzjoni mill-app ta' awtentiċazzjoni"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol il-kodiċi ta' awtentikazzjoni"])}
          }
        }
      },
      "nb-NO": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering og lenking av autentiseringsapp ved å skrive inn og bekrefte en gyldig autentiseringskode fra appen."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skan QR-koden eller bruk koden nedenfor for å generere autentiseringskoder i en autentiseringsapp."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekrefte"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden er ugyldig"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode fra autentiseringsappen"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn godkjenningskode"])}
          }
        }
      },
      "nl-BE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activering en koppeling van de authenticatie-app door het invoeren en bevestigen van een geldige authenticatiecode van de app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan de QR-code of gebruik de code hieronder om verificatiecodes aan te maken in een verificatie-app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])}
          }
        }
      },
      "nl-NL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activering en koppeling van de authenticatie-app door het invoeren en bevestigen van een geldige authenticatiecode van de app."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan de QR-code of gebruik de onderstaande code om verificatiecodes te genereren in een verificatie-app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])}
          }
        }
      },
      "pl-PL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywacja i połączenie aplikacji uwierzytelniającej poprzez wprowadzenie i potwierdzenie prawidłowego kodu uwierzytelniającego z aplikacji."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacja do uwierzytelniania"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeskanuj kod QR lub użyj kodu znajdującego się poniżej, aby wygenerować kody uwierzytelniania w aplikacji uwierzytelniania."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania jest nieprawidłowy"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania z aplikacji uwierzytelniania"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź kod uwierzytelniania"])}
          }
        }
      },
      "pt-PT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativação e associação do aplicativo de autenticação ao inserir e confirmar um código de autenticação válido do aplicativo."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicativo de autenticação"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digitalize o código QR ou use o código abaixo para gerar códigos de autenticação em um aplicativo de autenticação."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação é inválido"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação do aplicativo de autenticação"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insira o código de autenticação"])}
          }
        }
      },
      "ro-RO": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activarea și conectarea aplicației de autentificare prin introducerea și confirmarea unui cod de autentificare valid din aplicație."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicație de autentificare"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scanați codul QR sau utilizați codul de mai jos pentru a genera coduri de autentificare într-o aplicație de autentificare."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare este invalid"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare din aplicația de autentificare"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți codul de autentificare"])}
          }
        }
      },
      "ru-RU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активация и привязка приложения аутентификации путем ввода и подтверждения действительного кода аутентификации из приложения."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение для аутентификации"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сканируйте QR-код или используйте код ниже, чтобы генерировать коды аутентификации в приложении аутентификации."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации недействителен"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации из приложения аутентификации"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите код аутентификации"])}
          }
        }
      },
      "sk-SK": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivácia a prepojenie autentifikačnej aplikácie zadaním a potvrdením platného autentifikačného kódu z aplikácie."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačná aplikácia"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naskenujte QR kód alebo použite kód nižšie na generovanie overovacích kódov v overovacej aplikácii."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód je neplatný"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizačný kód z autentizačnej aplikácie"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte overovací kód"])}
          }
        }
      },
      "sl-SI": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija in povezovanje aplikacije za avtentikacijo z vnosom in potrditvijo veljavne avtentikacijske kode iz aplikacije."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za avtentikacijo"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenirajte QR kodo ali uporabite kodo spodaj za generiranje overitvenih kod v aplikaciji za overjanje."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za overitev je neveljavna"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avtentikacijska koda iz avtentikacijske aplikacije"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite kodo za preverjanje pristnosti"])}
          }
        }
      },
      "sv-SE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering och länkning av autentiseringsappen genom att ange och bekräfta en giltig autentiseringskod från appen."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skanna QR-koden eller använd koden nedan för att generera autentiseringskoder i en autentiseringsapp."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden är ogiltig"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod från autentiseringsappen"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange autentiseringskod"])}
          }
        }
      },
      "th-TH": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การเปิดใช้งานและการเชื่อมโยงแอพพลิเคชันการยืนยันความถูกต้องโดยการป้อนและยืนยันรหัสการยืนยันความถูกต้องจากแอพพลิเคชัน"])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["แอปพลิเคชันการรับรองความถูกต้อง"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["สแกนรหัส QR หรือใช้รหัสด้านล่างเพื่อสร้างรหัสยืนยันในแอปพลิเคชั่นการยืนยัน"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ยืนยัน"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการตรวจสอบไม่ถูกต้อง"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการรับรองจากแอปการรับรองความถูกต้อง"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนรหัสยืนยัน"])}
          }
        }
      },
      "tr-CY": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uygulamadan geçerli bir kimlik doğrulama kodu girilerek ve onaylanarak kimlik doğrulama uygulamasının etkinleştirilmesi ve bağlanması."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR kodunu tarayın veya aşağıdaki kodu kullanarak bir kimlik doğrulama uygulamasında kimlik doğrulama kodları oluşturun."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodu geçersiz"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])}
          }
        }
      },
      "tr-TR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uygulamadan geçerli bir kimlik doğrulama kodu girerek ve onaylayarak kimlik doğrulama uygulamasının etkinleştirilmesi ve bağlantı kurulması."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QR kodunu tarayın veya aşağıdaki kodu kullanarak bir kimlik doğrulama uygulamasında kimlik doğrulama kodları oluşturun."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodu geçersiz"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])}
          }
        }
      },
      "uk-UA": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активація та зв'язування програми аутентифікації шляхом введення та підтвердження дійсного коду аутентифікації з програми."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Додаток для автентифікації"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скануйте QR-код або використовуйте код нижче для генерації кодів автентифікації в додатку для автентифікації."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації недійсний"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації з додатка автентифікації"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть код автентифікації"])}
          }
        }
      },
      "vi-VN": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kích hoạt và liên kết ứng dụng xác thực bằng cách nhập và xác nhận mã xác thực hợp lệ từ ứng dụng."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ứng dụng Xác thực"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quét mã QR hoặc sử dụng mã dưới đây để tạo mã xác thực trong ứng dụng xác thực."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Xác nhận"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực không hợp lệ"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực từ ứng dụng xác thực"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập mã xác thực"])}
          }
        }
      },
      "zh-CN": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过从应用程序中输入和确认有效的认证代码，激活和连接认证应用程序."])}
        },
        "authenticatorSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证应用"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扫描QR码或使用下面的代码在认证应用中生成认证代码。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "notification": {
          "fetchSecret": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证代码无效"])}
            }
          }
        },
        "authenticatorOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["来自身份验证应用的身份验证代码"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入认证码"])}
          }
        }
      }
    }
  })
}
